export const URL_TEACHER_FIRST_ACCESS =
  'https://professor.alunoensina.com/primeiro_acesso';

export const PORTAL_STUDENT = 'https://aluno.alunoensina.com';
export const PORTAL_TEACHER = 'https://teacher.alunoensina.com';
export const PORTAL_ADMIN = 'https://admin.alunoensina.com';
export const PORTAL_MAIN = 'https://alunoensina.com';
